import { render, staticRenderFns } from "./SuperadminTenantSwitcher.vue?vue&type=template&id=53833410&scoped=true"
import script from "./SuperadminTenantSwitcher.vue?vue&type=script&lang=js"
export * from "./SuperadminTenantSwitcher.vue?vue&type=script&lang=js"
import style0 from "./SuperadminTenantSwitcher.vue?vue&type=style&index=0&id=53833410&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53833410",
  null
  
)

export default component.exports